<template>
    <section>
            <v-data-table :headers="headers"
                        :items="GetCourseList" 
                        :pagination.sync="pagination" 
                        select-all 
                        item-key="Course_Title" 
                        hide-actions
                        disable-initial-sort
                        class="elevation-1">
                <template v-slot:headers="props">
                    <tr>
                        <th v-for="header in props.headers" :key="header.text" :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']" @click="SortColumn(header.value)">
                        <v-icon small>arrow_upward</v-icon> {{ header.text }}
                        </th>
                    </tr>
                </template>
                <template v-slot:items="props">
                    <tr :active="props.selected" @click="props.selected = !props.selected">
                        <td class="text-xs-center">{{ props.item.Course_Title }}</td>
                        <td class="text-xs-center">{{ props.item.Features.length }}</td>
                        <td class="text-xs-center">
                            <v-btn color="primary" icon class="btnAction" @click="OpenUpdateFeatureModal(props.item,'Update')">
                                <v-icon>edit</v-icon>
                            </v-btn>
                            <v-btn color="error" icon class="btnAction" @click="OpenUpdateFeatureModal(props.item,'Delete')">
                                <v-icon>delete</v-icon>
                            </v-btn>
                        </td>
                    </tr>
                </template>
            </v-data-table>
            <pagination v-model="pages" :records="records" :per-page="10" @paginate="GetNextSetOfData"></pagination>
        <app-update-Feature ref="UpdateSection" :dialog="UpdateFeature" @close='CloseDialog'></app-update-Feature>
    </section>
</template>
<script>

import appUpdateCurriculam  from '../dialogs/UpdateCurriculam'
import appUpdateFeature     from '../dialogs/AddFeatures'

export default {
    components: {
        appUpdateCurriculam,
        appUpdateFeature
    },
    data(){

        return {

            pagination       : { sortBy: 'Course_Title'},
            headers          : [ { text: 'Course Title',value: 'Course_Title' },
                                 { text: 'No of Features' },
                                 { text: 'Actions' } ],
            UpdateFeature        : false,
            loading          : false,
            pages            : 1,
            records          : 0,  
        }
    },
    computed:{
        GetCourseList(){
            
            return this.$store.getters.GetCourseFeature
        }
    },
    methods:{
        SortColumn (column) {

            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending
            } else {
                this.pagination.sortBy = column
                this.pagination.descending = false
            }
      },
      OpenUpdateFeatureModal(Course,Type){
        if( type == 'edit' || (type == 'delete' && confirm("Do you really want to delete?"))){
          this.UpdateFeature  = true
          this.$refs.UpdateSection.GetFeatures(Course,Type)
        }
      },
      CloseDialog(){

          this.UpdateFeature    = false
      },
      GetNextSetOfData(){

            this.$http.post(`${this.$store.getters.GetProductionUrl}/coursefeature/getcoursefeatures`,{ limit:10, page : this.pages })
                        .then(response =>{
                            
                            this.$store.commit('SetCourseFeaturesList',response["data"]["response"])
                            this.records = response["data"]["Records"]
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                        })
      }
    },
    mounted(){
            
        this.GetNextSetOfData()
    }
}
</script>
<style>
.VuePagination ul{
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
 }
.VuePagination li{
    border: 1px solid #887a7a0f !important;
 }
 .pagination {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
}
.page-link {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: #007bff;
    background-color: #fff;
    border: 1px solid #dee2e6;
    text-decoration: none;
}
.VuePagination__count {
    font-size: 12px;
    font-weight: bold;
    text-align: right;
    text-transform: capitalize;
}
</style>


